/**
 * Marcas del documento `empresas`: fuente canónica es el array `marcas`.
 * No leer ni escribir `marcas_atendidas` en lógica nueva; migrar datos legacy en Firestore si aplica.
 *
 * @param {object|null|undefined} empresa
 * @returns {string[]}
 */
export function getEmpresaMarcas(empresa) {
  if (!empresa || typeof empresa !== 'object') return [];
  const m = empresa.marcas;
  if (!Array.isArray(m)) return [];
  return m
    .map((x) => {
      if (typeof x === 'string') return x.trim();
      if (x != null && typeof x === 'object' && x.nombre != null) return String(x.nombre).trim();
      return String(x ?? '').trim();
    })
    .filter(Boolean);
}
